export const EXPERT_PARTNER_USER_GROUPS = [
    'BUBBLE_EXPERT',
    'BUILDSHIP_EXPERT',
    'FRAMER_EXPERT',
    'HEY_GEN_EXPERT',
    'INSTANT_EXPERT',
    'KITTL_EXPERT',
    'RELUME_EXPERT',
    'RIVE_EXPERT',
    'SPLINE_EXPERT',
    'WEBSTUDIO_EXPERT',
    'CONTRA_EXPERT_TEST',
    'WIX_STUDIO_EXPERT',
    'GLORIFY_EXPERT',
    'DESCRIPT_EXPERT',
    'REPLO_EXPERT',
    'JITTER_EXPERT',
    'WEBFLOW_EXPERT',
    'BOTSTACKS_EXPERT',
    'LOTTIEFILES_X_FIGMA_EXPERT',
    'LOTTIEFILES_X_WEBFLOW_EXPERT',
    'LOTTIEFILES_X_FRAMER_EXPERT',
    'FLUTTERFLOW_EXPERT',
];
export const EXPERT_PARTNER_PATHS = [
    'bubble',
    'buildship',
    'framer',
    'heygen',
    'instant',
    'kittl',
    'relume',
    'rive',
    'spline',
    'webstudio',
    'contra-test',
    'wixstudio',
    'glorify',
    'descript',
    'replo',
    'jitter',
    'webflow',
    'xano',
    'botstacks',
    'lottiefiles-figma',
    'lottiefiles-webflow',
    'lottiefiles-framer',
    'flutterflow',
];
export const EMAIL_BASE_ASSET_PATH = 'https://contra.com/static/email-assets/expert-badge-achievement/';
//# sourceMappingURL=constants.js.map